import axios from 'axios';
import store from './store/store';

//クレジットカード系のAPIだけ別のエンドポイントにしているため、axios経由でのリクエストを行う TODO どちらかに統一

let baseURL;
if (process.env.NODE_ENV === "production") {
  baseURL = "https://api.abceed.com/";
} else {
  baseURL = "https://2zw3cqudp7.execute-api.ap-northeast-1.amazonaws.com/dev/";
}

const apiClient = axios.create({
  baseURL: baseURL
});
apiClient.defaults.headers.common['Content-Type'] = "application/json";
apiClient.interceptors.request.use(function (config) {
  const sessionToken = window.localStorage.getItem(['sessionToken']);
  if (sessionToken) {
    config.headers.authorization = `Bearer ${sessionToken}`;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    window.localStorage.clear();
    store.dispatch('hideLightBox');
    store.dispatch('resetAllStore');
  }
  return Promise.reject(error);
});
export default apiClient;



// WEBPACK FOOTER //
// ./src/axios.js